import { useShopStore } from "../store/shop";

//make random id
export const useStoreId = function () {
  let shopStore = useShopStore();
  return shopStore.storeId;
};
